import { useEffect, useState } from 'react';
import { useMaterialsPanelStore } from '../stores/materialsPanelStore';
import { useIsMobile } from '../hooks/useIsMobile';
import GenerationWorkspace from '../components/generation/GenerationWorkspace';
import MaterialsFloatingOpenButton from '../components/panels/MaterialsFloatingOpenButton';
import './MaterialsPage.css';

interface MaterialsPageProps {
  /** 素材パネルのデフォルトフォルダ（shared: 共有, personal: 個人） */
  defaultFolder?: 'shared' | 'personal';
}

export default function MaterialsPage({ defaultFolder: _defaultFolder }: MaterialsPageProps) {
  const { open, isOpen } = useMaterialsPanelStore();
  const isMobile = useIsMobile();
  const [isResizing, setIsResizing] = useState(false);

  // 初回マウント時のみパネルを開く（スマホ時・studio/video配下・トップページでは閉じたまま、ただしpromptモードは除く）
  useEffect(() => {
    if (!isMobile) {
      const path = window.location.pathname;
      // トップページ（/）では自動で開かない（OEMトップページの初期状態は閉じる仕様）
      if (path === '/') return;
      // studio/video/promptではパネルを開く
      const isVideoPromptPage = path === '/studio/video/prompt';
      // studio/video配下（/studio/video, /studio/video/:id）では自動でパネルを開かない
      const isVideoPage = /^\/studio\/video(\/|$)/.test(path);
      if (!isVideoPage || isVideoPromptPage) {
        open('manage');
      }
    }
  }, [isMobile]);

  // リサイズ状態を監視
  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.classList.contains('resize-handle')) {
        setIsResizing(true);
      }
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div className={`materials-page ${isOpen ? 'panel-open' : 'panel-closed'} ${isResizing ? 'panel-resizing' : ''}`}>
      <div className="workspace-container">
        <GenerationWorkspace />
      </div>
      <MaterialsFloatingOpenButton />
    </div>
  );
}
